import * as React from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

import { AuthLogic } from '../auth/AuthLogic';
import { ProfileService } from '../services/ProfileService';
import { ISettings } from '../services/SettingsService';

export interface IUserMenuProps {
    baseUrl: string;
}

export interface IUserMenuState {
    dropdownClass: string;
    user: string;
    redirectToHomePage: boolean;
    active: string | null;
    avatar: string | null;
}

class UserMenu extends React.Component<IUserMenuProps, IUserMenuState> {
    private timerClose: NodeJS.Timer | null = null;
    constructor(props: IUserMenuProps) {
        super(props);
        this.state = {
            active: null,
            dropdownClass: 'closed',
            avatar: null,
            user: '',
            redirectToHomePage: false
        };
    }

    public componentDidMount() {
        this.reloadProfile();
    }

    public render() {
        if (this.state.redirectToHomePage === true) {
            return <Redirect to="/" />;
        }

        return (
            <div className="profileHolder__profile">
                <div
                    className={'with-dropdown ' + this.state.dropdownClass}
                    onMouseLeave={() => this.onMouseLeave()}
                    onMouseEnter={() => this.onMouseEnter()}
                >
                    <span onClick={() => this.toggleDropdown()}>
                        <div
                            className={
                                'img' +
                                (this.state.avatar !== null
                                    ? ' transparent'
                                    : '')
                            }
                        >
                            {this.state.avatar !== null && (
                                <img
                                    src={this.state.avatar}
                                    alt={this.state.user}
                                />
                            )}
                        </div>
                        <span>{this.state.user}</span>
                    </span>

                    <div className="transparent-border" />

                    <ul className={'dropdown ' + this.state.dropdownClass}>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/settings`}
                                onClick={() => this.setActive('account')}
                            >
                                My Account
                            </Link>
                        </li>
                        <li>
                            <span
                                onClick={() => AuthLogic.getInstance().logout()}
                            >
                                Logout
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    private async reloadProfile() {
        const result = await ProfileService.getInstance().reloadProfile();
        if (result != undefined && (result as ISettings) != undefined) {
            const temp = result as ISettings;

            let userName = '';
            if (temp.name && temp.surname && (temp.name.trim() + temp.surname.trim()) !== '') {
                userName = temp.name.trim() + ' ' + temp.surname.trim();
            } else if (temp.contactEmail && temp.contactEmail !== '') {
                userName = temp.contactEmail;
            } else if (temp.nickname && temp.nickname !== '') {
                userName = temp.nickname;
            }

            this.setState({
                user: userName
            });

            if (temp.picture != undefined) {
                this.setState({
                    avatar: temp.picture
                });
            }
        } else {
            this.setState({
                redirectToHomePage: true
            });
        }
    }

    private toggleDropdown() {
        let newClass =
            this.state.dropdownClass === 'closed' ? 'opened' : 'closed';
        this.setState({
            dropdownClass: newClass
        });
    }

    private closeDropDown() {
        this.setState({
            dropdownClass: 'closed'
        });
    }

    private onMouseLeave() {
        this.timerClose = setTimeout(() => {
            this.closeDropDown();
            this.timerClose = null;
        }, 700);
    }

    private onMouseEnter() {
        if (this.timerClose !== null) {
            clearTimeout(this.timerClose);
            this.timerClose = null;
        }
    }

    private setActive(active: string) {
        this.setState({
            active: active,
            dropdownClass: 'closed'
        });
    }
}

export default UserMenu;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UserMenu.tsx